jQuery(function($) {
    var component = {
        $selectors: {
            fitGuideWrapper: $('.fit-guide'),
            fitGuideOpenTrigger: $('.fit-guide__toggle'),
            fitGuideClose: $('.fit-guide__close'),
            body: $('body'),
            html: $('html'),
            fitGuideAnchorLinks: $('.fit-guide__anchor-link'),
            header: $('header'),
            window: $(window),
            document: $(document)
        },

        init: function() {
            this.$selectors.fitGuideOpenTrigger.on('click', this.methods._open.bind(this))
            this.$selectors.body.on('click', this.methods._close.bind(this))
            this.$selectors.fitGuideAnchorLinks.on('click', this.methods._scrollToAnchor.bind(this))
            this.$selectors.window.on('resize', this.methods._onResize.bind(this))
            this.$selectors.document.ready(this.methods._onResize.bind(this))
            this.$selectors.document.ready(this.methods._initMobileSlider.bind(this))
            this.$selectors.document.on('keyup', this.methods._closeOnEsc.bind(this))
            this.$selectors.fitGuideWrapper.on('scroll', this.methods._scroll.bind(this))
        },

        methods: {
            _open: function(e) {
                e.preventDefault();
                this.$selectors.fitGuideWrapper.addClass('open')
                this.$selectors.body.addClass('overflow-hidden')
                this.$selectors.html.addClass('overflow-hidden')
            },

            _closeOnEsc: function(e) {
                if (e.key === 'Escape') {
                    this.$selectors.fitGuideWrapper.removeClass('open')
                    this.$selectors.body.removeClass('overflow-hidden')
                    this.$selectors.html.removeClass('overflow-hidden')
                }
            },

            _close: function(e) {
                if (
                    (e.target.closest('.fit-guide') === null
                    || e.target.closest('.fit-guide__close') !== null)
                    && e.target.closest('.fit-guide__toggle') === null
                   ) {
                    this.$selectors.fitGuideWrapper.removeClass('open')
                    this.$selectors.body.removeClass('overflow-hidden')
                    this.$selectors.html.removeClass('overflow-hidden')
                }
            },

            _scroll: function(e) {
                const defaultOffset = 8
                const scrollTop = this.$selectors.fitGuideWrapper.scrollTop() + defaultOffset
                const topValueCSS =  scrollTop ? scrollTop + 'px' : defaultOffset + 'px'
                this.$selectors.fitGuideClose.css('top', topValueCSS)
            },

            _scrollToAnchor: function(e) {
                e.preventDefault()
                document.getElementById(e.target.closest('a').getAttribute('href').replace('#', '')).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            },

            _onResize: function(e) {
                const headerHeight = this.$selectors.header.outerHeight() + 'px';
                this.$selectors.fitGuideWrapper.css({
                    'top': headerHeight,
                    'height': 'calc(100vh - '+ headerHeight +')'
                })
            },

            _initMobileSlider: function(e) {
                const $fitGuideMobileSlider = new Swiper('#fit-guide__nav-slider .swiper-container', {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 0,
                    centerInsufficientSlides: true,
                    breakpoints: {
                        375: {
                            slidesPerView: 3,
                            slidesPerGroup: 3
                        },
                        640: {
                          slidesPerView: 4,
                          slidesPerGroup: 4
                        }
                    },
                    navigation: {
                      nextEl: '#fit-guide__nav-slider .swiper-button-next',
                      prevEl: '#fit-guide__nav-slider .swiper-button-prev',
                    }
                })
            }
        }
    }

    component.init()
});
